import { taggedTemplateLiteral as _taggedTemplateLiteral, slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState } from 'react';
import Theme from '../../Theme/index.js';
import styled from 'styled-components';
import DatePicker from '../../_virtual/react-datepicker.min.js';
import PropTypes from 'prop-types';

var _templateObject;
var StyledPicker = styled(DatePicker)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 48px;\n  border: 1px solid\n    ", ";\n  font-family: ", ";\n  outline: none;\n  font-size: 1rem;\n  padding: 0.375rem 0.75rem;\n  width: 100%;\n  background-color: ", ";\n  transition: border-color 0.15s ease-in-out;\n  &:focus {\n    border: 2px solid\n      ", ";\n    background-color: #fff;\n  }\n"])), function (_ref) {
  var hasError = _ref.hasError;
  return hasError ? Theme.colors.danger : Theme.colors.darkgrey;
}, Theme.fonts.Montserrat, function (_ref2) {
  var hasError = _ref2.hasError;
  return hasError ? Theme.colors.dangerLight : "#fff";
}, function (_ref3) {
  var hasError = _ref3.hasError;
  return hasError ? Theme.colors.danger : Theme.colors.lightBlue;
});
var useSetDate = function useSetDate(setFieldValueFn, name) {
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    startDate = _useState2[0],
    setStartDate = _useState2[1];
  var setDate = function setDate(e) {
    setStartDate(e);
    setFieldValueFn(name, startDate);
  };
  return [startDate, setDate];
};
var FormikDatePicker = function FormikDatePicker(_ref4) {
  var name = _ref4.name,
    placeholder = _ref4.placeholder,
    setFieldValue = _ref4.setFieldValue,
    className = _ref4.className,
    hasError = _ref4.hasError;
  var _useSetDate = useSetDate(setFieldValue, name),
    _useSetDate2 = _slicedToArray(_useSetDate, 2),
    startDate = _useSetDate2[0],
    setDate = _useSetDate2[1];
  return /*#__PURE__*/React__default.createElement(StyledPicker, {
    className: className,
    name: name,
    hasError: hasError,
    placeholderText: placeholder,
    isClearable: true,
    onChange: setDate,
    selected: startDate
  });
};
FormikDatePicker.displayName = "FormikDatePicker";
FormikDatePicker.propTypes = {
  name: PropTypes.string.isRequired,
  hasError: PropTypes.bool,
  placeholder: PropTypes.string,
  setFieldValue: PropTypes.func.isRequired,
  className: PropTypes.any
};

export { FormikDatePicker, StyledPicker, FormikDatePicker as default, useSetDate };
